const HilightCard = ({ badge, image, title, description }) => {
  return (
    <div className="flex flex-col gap-5 md:gap-8 w-full md:w-1/2">
      {/**Upper */}
      <div className="flex flex-col items-start gap-3 md:gap-4 self-stretch">
        <div className="flex py-0.5 px-2.5 md:px-3 justify-center items-center gap-2.5 rounded-xl bg-navy-blue-03 text-white text-[10px] leading-[20px] md:text-[12px] md:leading-[22px] font-medium font-google">
          <span className="text-[12px]">{badge}</span>
        </div>
        {/* <div
          className="
          w-full max-w-[328px] md:max-w-none md:w-full
          rounded-lg border border-black/10
          bg-cover bg-center bg-no-repeat"
          style={{
            backgroundImage: `url(${image})`,
          }}
        /> */}
        <img
          src={image}
          alt={title}
          className="rounded-lg border border-black/10 w-full"
        />
      </div>
      {/**Lower */}

      <div className="flex flex-col items-start gap-3 md:gap-2 self-stretch ">
        <p className="text-grey-09 text-[18px] leading-[32px] md:text-[24px] md:leading-[32px] font-google font-medium">
          {title}
        </p>
        <p className="text-grey-05 text-[14px] leading-[24px] md:text-[16px] md:leading-[24px] font-inter font-normal">
          {description}
        </p>
      </div>
    </div>
  );
};
export default HilightCard;
